import { render, staticRenderFns } from "./projectsType.vue?vue&type=template&id=a89d3260&"
import script from "./projectsType.vue?vue&type=script&lang=js&"
export * from "./projectsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports